import lodash from 'lodash'

export function getRandomIdSuffix () {
  return `${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
}

export function getLatestHistoryByStatus (histories, status) {
  if (!histories || !status) {
    return undefined
  }
  const orderedHistories = lodash.sortBy(histories, history => {
    return new Date(history.createdAt)
  })
  return orderedHistories[lodash.findLastIndex(orderedHistories, (item) => status === item.status)]
}
